export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione di un assegno elettronico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conto di accredito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serie"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di attivazione"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifica"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva assegno elettronico"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Importo"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stato"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivo"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annullato"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivazione"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Restituzione"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In attesa"])}
  }
}